import { BASE_URL } from "../BaseUrl.js"; 
import axios from "axios";

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("momo4scoohclient")
  if (token) {
    config.headers.Authorization =  `Bearer ${token}`;
  } else {
    config.headers.Authorization =  null;
  }

  return config;
});

export const getListeUtilisateur = async (page, size, param) => {
  return await axios.get(
    BASE_URL(`adminentite/rechercherutilisateurs?page=${page}&size=${size}&param=${param}`),
    {}
  );
};

export const ajoutUtilisateurSchool = async (values) => {
  return await axios.post(
    BASE_URL("adminetablissement/enregistrerUtilisateur"),
    values
  );
};

export const ajoutUtilisateur = async (values) => {
  return await axios.post(
    BASE_URL("adminclient/enregistrerutilisateurclient"),
    values
  );
};

export const modificationUtilisateur = async (values) => {
  return await axios.post(
    BASE_URL("adminetablissement/modifierUtilisateur"),
    values
  );
};

export const rechercherUtilisateurParParam = async (page, size, param = "", annee = "", niveau = "") => {
  return await axios.get(
    BASE_URL(`etablissement/listeeleves?anneeId=${annee}&niveauId=${niveau}&page=${page}&param=${param}&size=${size}`),
    {}
  );
};

export const supprimerUtilisateurParId = async (userId) => {
  return await axios.post(
    BASE_URL(`admin/zzdz/${userId}`),
    {}
  );
};

export const changerEtatUtilisateurParId = async (userId) => {
  return await axios.post(
    BASE_URL(`adminetablissement/changeretatcompteutilisateur/${userId}`),
    {}
  );
};

export const modifierIdentifiantAdmin = async (values) => {
  return await axios.post(
    BASE_URL("reinitialiserpassword"),
    values
  );
};